import { useSearchParams } from 'react-router-dom';

import { useState } from 'react';
import { useSelector } from 'react-redux';
import DeductionsModal from './DeductionBody';
import styles from './index.module.scss';

const DeductionTab = (props: any) => {
	const { activeTab, isUsd } = props;
	const [searchParams] = useSearchParams();
	const [earningsAmount, setEarningsAmount] = useState<number>(0);

	const { baseCurrencySymbol, usdCurrencySymbol } = useSelector(
		(state: any) => state.userProfile.data
	);

	const [isFetchDataLoading, setIsFetchDataLoading] =
		useState<boolean>(false);

	return (
		<div>
			<div className={styles.deductionContainer}>
				<div className={styles.headerBox}>
					<div className={styles.headerContent}>
						<div className={styles.titleContainer}>
							<div className={styles.titleText}>
								{'Deductions'}
							</div>
							<div className={styles.separation}></div>
							<div className={styles.earningsCount}>
								<div className={styles.titleEarnings}>
									Total Deductions
								</div>
								<div className={styles.earningsAmount}>
									{isUsd
										? usdCurrencySymbol
										: baseCurrencySymbol}
									{!isFetchDataLoading &&
										Boolean(earningsAmount) &&
										earningsAmount?.toFixed(2)}
								</div>
							</div>
						</div>
					</div>
				</div>
				<DeductionsModal
					activeTab={activeTab}
					employeeId={searchParams.get('employeeId') as string}
					isUSD={isUsd}
					isLoading={isFetchDataLoading}
					setIsLoading={setIsFetchDataLoading}
					setEarningsAmount={setEarningsAmount}
				/>
			</div>
		</div>
	);
};

export default DeductionTab;
